/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type { CustomSSLRequest, CustomSSLResponse, Error, SiteID } from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns all custom SSL certificates uploaded for this site, including issuer, expiration, domains covered, and certificate fingerprint.
 * @summary List custom SSL certificates
 */
export const listSiteSslCertificates = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<CustomSSLResponse[]>({
    url: `/v1/sites/${id}/ssl/certificates`,
    method: 'GET',
    signal,
  });
};

export const getListSiteSslCertificatesQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/ssl/certificates`] as const;
};

export const getListSiteSslCertificatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteSslCertificatesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteSslCertificates>>> = ({
    signal,
  }) => listSiteSslCertificates(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/ssl/certificates`,
      operationId: 'app.controllers.custom_ssl_controller.list_site_ssl_certificates',
      operationName: 'listSiteSslCertificates',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteSslCertificates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteSslCertificatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteSslCertificates>>
>;
export type ListSiteSslCertificatesQueryError = Error;

export function useListSiteSslCertificates<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteSslCertificates>>,
          TError,
          Awaited<ReturnType<typeof listSiteSslCertificates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSslCertificates<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteSslCertificates>>,
          TError,
          Awaited<ReturnType<typeof listSiteSslCertificates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSslCertificates<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List custom SSL certificates
 */

export function useListSiteSslCertificates<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteSslCertificatesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteSslCertificatesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteSslCertificatesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteSslCertificates>>> = ({
    signal,
  }) => listSiteSslCertificates(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/ssl/certificates`,
      operationId: 'app.controllers.custom_ssl_controller.list_site_ssl_certificates',
      operationName: 'listSiteSslCertificates',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteSslCertificates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteSslCertificatesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteSslCertificates>>
>;
export type ListSiteSslCertificatesSuspenseQueryError = Error;

export function useListSiteSslCertificatesSuspense<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSslCertificatesSuspense<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSslCertificatesSuspense<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List custom SSL certificates
 */

export function useListSiteSslCertificatesSuspense<
  TData = Awaited<ReturnType<typeof listSiteSslCertificates>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSslCertificates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteSslCertificatesSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload your own SSL certificate and private key for one or more domains on this site, replacing the default automatically managed certificate for those domains.
 * @summary Upload a custom SSL certificate
 */
export const createSiteSslCertificate = (
  id: SiteID,
  customSSLRequest: CustomSSLRequest,
  signal?: AbortSignal
) => {
  return customFetch<CustomSSLResponse>({
    url: `/v1/sites/${id}/ssl/certificates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: customSSLRequest,
    signal,
  });
};

export const getCreateSiteSslCertificateMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteSslCertificate>>,
    TError,
    { id: SiteID; data: CustomSSLRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteSslCertificate>>,
  TError,
  { id: SiteID; data: CustomSSLRequest },
  TContext
> => {
  const mutationKey = ['createSiteSslCertificate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteSslCertificate>>,
    { id: SiteID; data: CustomSSLRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteSslCertificate(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ssl/certificates` },
    {
      operationId: 'app.controllers.custom_ssl_controller.create_site_ssl_certificate',
      operationName: 'createSiteSslCertificate',
    }
  );

  return customOptions;
};

export type CreateSiteSslCertificateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteSslCertificate>>
>;
export type CreateSiteSslCertificateMutationBody = CustomSSLRequest;
export type CreateSiteSslCertificateMutationError = Error;

/**
 * @summary Upload a custom SSL certificate
 */
export const useCreateSiteSslCertificate = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteSslCertificate>>,
      TError,
      { id: SiteID; data: CustomSSLRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteSslCertificate>>,
  TError,
  { id: SiteID; data: CustomSSLRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteSslCertificateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns details for a specific custom SSL certificate, including issuer, serial number, fingerprint, upload date, issue date, expiration, and covered domains.
 * @summary Get custom SSL certificate details
 */
export const findSiteSslCertificate = (id: SiteID, certificateId: string, signal?: AbortSignal) => {
  return customFetch<CustomSSLResponse>({
    url: `/v1/sites/${id}/ssl/certificates/${certificateId}`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteSslCertificateQueryKey = (id?: SiteID, certificateId?: string) => {
  return [`/v1/sites/${id}/ssl/certificates/${certificateId}`] as const;
};

export const getFindSiteSslCertificateQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSslCertificateQueryKey(id, certificateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSslCertificate>>> = ({ signal }) =>
    findSiteSslCertificate(id, certificateId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, certificateId },
    {
      url: `/v1/sites/${id}/ssl/certificates/${certificateId}`,
      operationId: 'app.controllers.custom_ssl_controller.find_site_ssl_certificate',
      operationName: 'findSiteSslCertificate',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteSslCertificate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSslCertificateQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteSslCertificate>>
>;
export type FindSiteSslCertificateQueryError = Error;

export function useFindSiteSslCertificate<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSslCertificate>>,
          TError,
          Awaited<ReturnType<typeof findSiteSslCertificate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSslCertificate<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSslCertificate>>,
          TError,
          Awaited<ReturnType<typeof findSiteSslCertificate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSslCertificate<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get custom SSL certificate details
 */

export function useFindSiteSslCertificate<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSslCertificateQueryOptions(id, certificateId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteSslCertificateSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSslCertificateQueryKey(id, certificateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSslCertificate>>> = ({ signal }) =>
    findSiteSslCertificate(id, certificateId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, certificateId },
    {
      url: `/v1/sites/${id}/ssl/certificates/${certificateId}`,
      operationId: 'app.controllers.custom_ssl_controller.find_site_ssl_certificate',
      operationName: 'findSiteSslCertificate',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteSslCertificate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSslCertificateSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteSslCertificate>>
>;
export type FindSiteSslCertificateSuspenseQueryError = Error;

export function useFindSiteSslCertificateSuspense<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSslCertificateSuspense<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSslCertificateSuspense<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get custom SSL certificate details
 */

export function useFindSiteSslCertificateSuspense<
  TData = Awaited<ReturnType<typeof findSiteSslCertificate>>,
  TError = Error,
>(
  id: SiteID,
  certificateId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSslCertificate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSslCertificateSuspenseQueryOptions(id, certificateId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a custom SSL certificate and restores automatically managed SSL for the affected domains.
 * @summary Remove a custom SSL certificate
 */
export const deleteSiteSslCertificate = (id: SiteID, certificateId: string) => {
  return customFetch<void | void>({
    url: `/v1/sites/${id}/ssl/certificates/${certificateId}`,
    method: 'DELETE',
  });
};

export const getDeleteSiteSslCertificateMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteSslCertificate>>,
    TError,
    { id: SiteID; certificateId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteSslCertificate>>,
  TError,
  { id: SiteID; certificateId: string },
  TContext
> => {
  const mutationKey = ['deleteSiteSslCertificate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteSslCertificate>>,
    { id: SiteID; certificateId: string }
  > = props => {
    const { id, certificateId } = props ?? {};

    return deleteSiteSslCertificate(id, certificateId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ssl/certificates/{certificateId}` },
    {
      operationId: 'app.controllers.custom_ssl_controller.delete_site_ssl_certificate',
      operationName: 'deleteSiteSslCertificate',
    }
  );

  return customOptions;
};

export type DeleteSiteSslCertificateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteSslCertificate>>
>;

export type DeleteSiteSslCertificateMutationError = Error;

/**
 * @summary Remove a custom SSL certificate
 */
export const useDeleteSiteSslCertificate = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteSslCertificate>>,
      TError,
      { id: SiteID; certificateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteSslCertificate>>,
  TError,
  { id: SiteID; certificateId: string },
  TContext
> => {
  const mutationOptions = getDeleteSiteSslCertificateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
